import { render, staticRenderFns } from "./proposal-item-expenditure.vue?vue&type=template&id=ea4d993e&scoped=true&"
import script from "./proposal-item-expenditure.vue?vue&type=script&lang=js&"
export * from "./proposal-item-expenditure.vue?vue&type=script&lang=js&"
import style0 from "./proposal-item-expenditure.vue?vue&type=style&index=0&id=ea4d993e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4d993e",
  null
  
)

export default component.exports